import React from 'react';
import BarChart from '.././../containers/Charts/BarChart';
import LineChart from '.././../containers/Charts/LineChart';
import FinancialInfo from './FinancialInfo/FinancialInfo';
import './StockDetails.css';

const StockBalance = ({balanceSheet, aspect}) => {
    const assetData = {
        labels: balanceSheet?.timeBasedSheets[1]?.columnHeadings,
        datasets: [
            {
                data: balanceSheet?.timeBasedSheets[1]?.chartData[0]?.values,
                label: balanceSheet?.timeBasedSheets[1]?.chartData[0]?.name,
                fill : true,
                backgroundColor: `#59d455a1`,
                borderColor: `#30a02cd2`,
                barThickness: 50,
            }
        ]
    }

    const liabilityData = {
        labels: balanceSheet?.timeBasedSheets[1]?.columnHeadings,
        datasets: [
            {
                data: balanceSheet?.timeBasedSheets[1]?.chartData[1]?.values,
                label: balanceSheet?.timeBasedSheets[1]?.chartData[1]?.name,
                fill : true,
                backgroundColor: `#dd3b4698`,
                borderColor: `#f8303e`,
                barThickness: 50,
            }
        ]
    }

    const debtToAssetData = {
            labels: balanceSheet?.timeBasedSheets[1]?.columnHeadings,
            datasets: [
                {
                    data: balanceSheet?.timeBasedSheets[1]?.chartData[2]?.values,
                    label: balanceSheet?.timeBasedSheets[1]?.chartData[2]?.name,
                    fill : true,
                    backgroundColor: `#d1475056`,
                    borderColor: `#ff424f`,
                    barThickness: 50,
                }
            ]
    }

    const barOptions = {
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },

                }
            ],
            y: {
                ticks: {
                    // Include a dollar sign in the ticks
                    callback: function(value, index, values) {
                        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumSignificantDigits: 3 }).format(value/10000000) + " Cr";
                        
                    }
                }
            }
        }
    }

    const lineOptions = {
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },

                }
            ],
        }
    }

    return (
        <div className="mt-4">
            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li className="nav-item btn-sm mx-2" role="presentation">
                    <button className="nav-link finance-link active" id="pills-babout-tab" data-bs-toggle="pill" data-bs-target="#pills-babout" type="button" role="tab" aria-controls="pills-babout" aria-selected="true">
                        <small><small>About</small></small>
                    </button>
                </li>
                <li className="nav-item btn-sm mx-2" role="presentation">
                    <button className="nav-link finance-link" id="pills-assets-tab" data-bs-toggle="pill" data-bs-target="#pills-assets" type="button" role="tab" aria-controls="pills-assets" aria-selected="false">
                        <small><small>Assets</small></small>
                    </button>
                </li>
                <li className="nav-item btn-sm mx-2" role="presentation">
                    <button className="nav-link finance-link" id="pills-liabilities-tab" data-bs-toggle="pill" data-bs-target="#pills-liabilities" type="button" role="tab" aria-controls="pills-liabilities" aria-selected="false">
                        <small> <small>Liabilities</small> </small>
                    </button>
                </li>
                <li className="nav-item btn-sm mx-2" role="presentation">
                    <button className="nav-link finance-link" id="pills-debt-tab" data-bs-toggle="pill" data-bs-target="#pills-debt" type="button" role="tab" aria-controls="pills-debt" aria-selected="false">
                        <small><small>Debt/Asset Ratio</small></small>
                    </button>
                </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="pills-babout" role="tabpanel" aria-labelledby="pills-babout-tab">
                    <FinancialInfo aspect={aspect}/>
                </div>
                <div className="tab-pane fade" id="pills-assets" role="tabpanel" aria-labelledby="pills-assets-tab">
                    <BarChart data={assetData} options={barOptions}/>
                </div>
                <div className="tab-pane fade" id="pills-liabilities" role="tabpanel" aria-labelledby="pills-liabilities-tab">
                    <BarChart data={liabilityData} options={barOptions}/>
                </div>
                <div className="tab-pane fade" id="pills-debt" role="tabpanel" aria-labelledby="pills-debt-tab">
                    <LineChart data={debtToAssetData} options={lineOptions}/>
                </div>
            </div>            
        </div>
    )
}

export default StockBalance
